import { gql } from "@grandvisionhq/graphql";
import { receiptUrlFailure } from "../../../fragments/operations/fragments/get-receipt-url-failure.js";
const GET_RECEIPT_URL = gql`
  query GetReceiptUrl($input: GuestUserReceipt!) {
    getReceiptUrl(input: $input) {
      ... on GetReceiptUrlSuccessResponse {
        receiptUrl
      }
      ...ReceiptUrlFailureFragment
    }
  }
  ${receiptUrlFailure}
`;
export {
  GET_RECEIPT_URL
};
//# sourceMappingURL=get-receipt-url.js.map
